<script lang="ts">
  let list = [
    {lable: "反动政治", value: 1 },
    {lable: "色情低俗", value: 2 },
    {lable: "内容侵权", value: 3 },
    {lable: "违法违禁", value: 4 },
    {lable: "虚假宣传", value: 5 },
    {lable: "其他", value: 6 }
  ]
  export let active = -1
  const makeActive = index => {
    if(active === index) {
      active = -1
      return
    }
    active = index
  }
  
  let warnFlag = false
  let timer = null
  export function boxWarn():void {
    clearTimeout(timer)
    warnFlag = true
    timer = setTimeout(() => {
      warnFlag = false
    }, 1500)
  }
</script>

<style lang="less" src="./Checkbox.less">
</style>

<div class="c-checkbox">
  {#each list as item}
  <div 
    class="c-checkbox--item {active === item.value ? 'active' : ''}" 
    style={`border-color: ${warnFlag ? '#db2e20': 'transparent' }`}
    on:click="{() => makeActive(item.value)}" 
  >
    {item.lable}
  </div>
  {/each}
</div>

